export class ListProjectsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "projects",
            "baseName": "projects",
            "type": "Array<Project>",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListProjectsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
